import axios from 'axios';
import {browserHistory} from 'react-router';
import {clear, getUserProperty} from './util/Session'; // eslint-disable-line import/no-cycle

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const withAuth = () => ({headers: {Authorization: `Bearer ${getUserProperty('token')}`}});

const v1 = axios.create({baseURL: '/api/v1', headers: headers});

const errorHandler = e => {
  // token is invalid, so force a logout
  if (e.response && e.response.status === 401) {
    clear();
    browserHistory.push('/login');
  }

  // don't know what to do - re-throw
  throw e;
};

export const authenticate = (email, password) => v1.post('/authentication/authenticate', {email, password});

export const signup = (school, user) => v1.post('/signup', {school, user})
  .catch(errorHandler);

export const findSchool = schoolCode => v1.get(`/schools?code=${schoolCode}`)
  .catch(errorHandler);

export const retrieveTeam = teamId => v1.get(`/teams/${teamId}`)
  .catch(errorHandler);

export const retrieveMyTeam = () => v1.get('/teams/me', withAuth())
  .catch(errorHandler);

export const findTeam = email => v1.get(`/teams?email=${encodeURIComponent(email)}`)
  .catch(errorHandler);

export const retrieveSchool = schoolId => v1.get(`/schools/${schoolId}`)
  .catch(errorHandler);

export const retrieveMySchool = () => v1.get('/schools/me', withAuth())
  .catch(errorHandler);

export const createUser = (schoolId, user) => v1.post(`/schools/${schoolId}/users`, user)
  .catch(errorHandler);

export const signupCommunityUser = (teamId, user) => v1.post(`/teams/${teamId}/signup`, user)
  .catch(errorHandler);

export const updateUser = (userId, user) => v1.patch(`/users/${userId}`, user, withAuth())
  .catch(errorHandler);

export const retrieveUser = (userId) => v1.get(`/users/${userId}`, withAuth())
  .catch(errorHandler);

export const toggleUserRole = (schoolId, userId, roleName) => v1.put(`schools/${schoolId}/users/${userId}/roles/${roleName}`, {}, withAuth())
  .catch(errorHandler);

export const loadActivities = () => v1.get('/activities', withAuth())
  .catch(errorHandler);

export const updateActivityType = (type, payload) => v1.put(`/activities/${type}`, payload, withAuth())
  .catch(errorHandler);

export const retrievePiggyBanks = () => v1.get('/piggy-banks', withAuth())
  .catch(errorHandler);

export const retrieveStudents = schoolId => v1.get(`/schools/${schoolId}/students`, withAuth())
  .catch(errorHandler);

export const retrieveStaff = schoolId => v1.get(`/schools/${schoolId}/staff`, withAuth())
  .catch(errorHandler);

export const retrieveSchoolUsers = schoolId => v1.get(`/schools/${schoolId}/users`, withAuth())
  .catch(errorHandler);

export const createSchoolSemester = (schoolId, startDate, endDate, pointsNeeded) => v1.post(`/schools/${schoolId}/semesters`, {start_date: startDate, end_date: endDate, points_needed: pointsNeeded}, withAuth())
  .catch(errorHandler);

export const retrieveSchoolSemesters = schoolId => v1.get(`/schools/${schoolId}/semesters`, withAuth())
  .catch(errorHandler);

export const updateActiveSchoolSemester = semesterId => v1.put(`/schools/semesters/${semesterId}/active`, {}, withAuth())
  .catch(errorHandler);

export const passwordReset = email => v1.post('/forgot-password', {email: email})
  .catch(errorHandler);

export const resetPassword = (token, email, password, passwordConfirmation) => v1.post('/reset-password', {token: token, email: email, password: password, password_confirmation: passwordConfirmation})
  .catch(errorHandler);

export const retrieveBalances = () => v1.get('/snapshots/weekly', withAuth());

export const createDonationStripeSession = teamId => v1.post('/stripe-donation-checkout-sessions', { team_id: teamId }, withAuth())
  .catch(errorHandler);

export const createTeamPayment = (teamId, stripeCheckoutSessionId) => v1.post(`/teams/${teamId}/payments`, { stripe_checkout_session_id: stripeCheckoutSessionId }, withAuth())
  .catch(errorHandler);

export const createSubscriptionPaymentSession = (schoolId, numStudents) => v1.post('/stripe-subscription-checkout-sessions', { school_id: schoolId, num_students: numStudents }, withAuth())
  .catch(errorHandler);

export const createSubscriptionPayment = (schoolId, stripeCheckoutSessionId) => v1.post(`/schools/${schoolId}/payments`, {stripe_checkout_session_id: stripeCheckoutSessionId}, withAuth())
  .catch(errorHandler);

export const retrieveTeamUsers = teamId => v1.get(`/teams/${teamId}/users`, withAuth())
  .catch(errorHandler);

export const retrieveSubscriptions = () => v1.get('/subscriptions', withAuth())
  .catch(errorHandler);



// WEBPACK FOOTER //
// ./src/api.js